import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "space-y-6 py-4" }
const _hoisted_2 = { class: "bg-gray-50 rounded-lg p-4 border border-gray-200" }
const _hoisted_3 = { class: "text-sm font-semibold text-gray-700 mb-3" }
const _hoisted_4 = { class: "flex flex-wrap gap-2 max-h-40 overflow-y-auto" }
const _hoisted_5 = { class: "space-y-2" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "text-xs text-gray-500" }
const _hoisted_9 = {
  key: 0,
  class: "text-green-400 font-normal ml-2"
}
const _hoisted_10 = { class: "bg-blue-50 border border-blue-200 rounded-lg p-4" }
const _hoisted_11 = { class: "flex items-start gap-3" }
const _hoisted_12 = { class: "bg-blue-100 rounded-full p-2" }
const _hoisted_13 = { class: "text-sm text-blue-400" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 0,
  class: "animate-spin rounded-full h-12 w-12 border-b-2 border-slate-600 mb-4"
}
const _hoisted_16 = { class: "space-y-6 py-4" }
const _hoisted_17 = { class: "bg-gray-50 rounded-lg p-4 border border-gray-200" }
const _hoisted_18 = { class: "text-sm font-semibold text-gray-700 mb-3" }
const _hoisted_19 = { class: "flex flex-wrap gap-2 max-h-60 overflow-y-auto" }
const _hoisted_20 = { class: "bg-blue-50 border border-blue-200 rounded-lg p-4" }
const _hoisted_21 = { class: "flex items-start gap-3" }
const _hoisted_22 = { class: "bg-blue-100 rounded-full p-2" }
const _hoisted_23 = { class: "flex-1" }
const _hoisted_24 = { class: "text-sm text-blue-700 mb-3" }
const _hoisted_25 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_26 = { class: "bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200 rounded-lg p-4 text-center" }
const _hoisted_27 = { class: "text-2xl font-bold text-purple-700" }
const _hoisted_28 = { class: "bg-gradient-to-br from-green-50 to-green-100 border border-green-200 rounded-lg p-4 text-center" }
const _hoisted_29 = { class: "text-2xl font-bold text-green-700" }
const _hoisted_30 = {
  key: 1,
  class: "flex items-center justify-center py-12"
}
const _hoisted_31 = { class: "text-red-500 text-sm" }
const _hoisted_32 = {
  key: 3,
  class: "rounded-md border m-8"
}
const _hoisted_33 = { class: "p-3 border-b-2" }
const _hoisted_34 = { class: "flex items-center mb-4" }
const _hoisted_35 = { class: "text-2xl font-bold text-gray-900 mb-2" }
const _hoisted_36 = { class: "text-gray-400" }
const _hoisted_37 = { class: "text-gray-600" }
const _hoisted_38 = {
  key: 0,
  class: "text-green-600 font-semibold ml-2"
}
const _hoisted_39 = { class: "ml-auto flex items-center space-x-3" }
const _hoisted_40 = { class: "relative max-w-md" }
const _hoisted_41 = {
  key: 0,
  class: "text-sm text-gray-600 mt-2"
}
const _hoisted_42 = ["title"]
const _hoisted_43 = { class: "flex flex-col items-center" }

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Calendar } from '@/components/ui/calendar'
import { Card, CardContent } from '@/components/ui/card'
import { Checkbox } from '@/components/ui/checkbox'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { useFetctApplicableYearTariffCodes } from "@/hooks/use-tariff-codes"
import { cn } from '@/lib/utils'
import { useSunsetStore } from '@/store/use-sunset-store'
import { format } from 'date-fns'
import {
  AlertCircle,
  ArrowRight,
  CalendarIcon,
  Eye,
  Merge,
  RepeatIcon,
  Search,
  SunsetIcon,
  Trash2,
  UploadIcon,
  X
} from 'lucide-vue-next'
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import TariffCodeDetailDialog from './TariffCodeDetailDialog.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'TariffCodesView',
  setup(__props) {

const router = useRouter()

const applicableYear = ref('2025')
const isDialogOpen = ref(false)
const isSyncSunsetDialogOpen = ref(false)
const isSyncDisciplinesDialogOpen = ref(false)
const tariff = ref<any>(null)
const sunsetDate = ref<Date>()
const isSyncing = ref(false)

// Search state
const searchQuery = ref('')

// Get Store
const sunsetStore = useSunsetStore()

// Destructure state with storeToRefs
// const { members, tariffCodes, sunset } = storeToRefs(sunsetStore)

// Format date to YYYY/MM/DD
const formatDateToYYYYMMDD = (date: Date | undefined) => {
  if (!date) return ''
  return format(date, 'yyyy/MM/dd')
}

// Just assign the object
const handleViewTariffCodeDetail = (tariffData: any) => {
  console.log('Tariff Detail:', tariffData)
  tariff.value = tariffData
  isDialogOpen.value = true
}

// Check if tariff is selected
const isSelected = (tariffItem: any) => {
  return tariffCodeSunsetDataList.value.some(
    selected => selected.rate_id === tariffItem.rate_id
  )
}

// Toggle selection
const toggleSelection = (tariffItem: any, checked: boolean | string) => {
  const isChecked = checked === true || checked === 'true' || checked === 'indeterminate'
  
  if (isChecked) {
    // tariffCodeStore.setTariffCodeSunsetData(tariffItem)
  } else {
    // tariffCodeStore.removeTariffCodeSunsetDataById(tariffItem.rate_id)
  }
}

// Select all visible (filtered) tariffs
const selectAll = () => {
  filteredTariffs.value.forEach((tariffItem: any) => {
    if (!isSelected(tariffItem)) {
      // tariffCodeStore.setTariffCodeSunsetData(tariffItem)
    }
  })
}

// Deselect all - clear the store
const deselectAll = () => {
  tariffCodeStore.clearTariffCodeSunsetDataList()
}

// Toggle header checkbox
const toggleSelectAll = () => {
  if (allVisibleSelected.value) {
    // Deselect only visible items
    filteredTariffs.value.forEach((tariffItem: any) => {
      if (isSelected(tariffItem)) {
        tariffCodeStore.removeTariffCodeSunsetDataById(tariffItem.rate_id)
      }
    })
  } else {
    selectAll()
  }
}

// Open Sync Sunset Dialog
const openSyncSunsetDialog = () => {
  isSyncSunsetDialogOpen.value = true
}

// Open Sync Disciplines Dialog
const openSyncDisciplinesDialog = () => {
  isSyncDisciplinesDialogOpen.value = true
}

// Handle Navigate to Stage Rollover
const navigateToStageRollover = () => {
  isSyncDisciplinesDialogOpen.value = false
  router.push('/eligible-health-seekers')
}

// Handle Sync Sunset
const handleSyncSunset = async () => {
  if (!sunsetDate.value) {
    alert('Please select a sunset date')
    return
  }

  isSyncing.value = true
  
  const formattedDate = formatDateToYYYYMMDD(sunsetDate.value)
  
  console.log('Syncing sunset for:', {
    selectedTariffs: tariffCodeSunsetDataList.value,
    sunsetDate: formattedDate
  })

  router.push("/eligible-health-seekers")
}

const handleSuccess = () => {}

// Fetch tariff codes based on applicable year
const {
  data: fetchedData,
  isLoading, 
  isError, 
  error, 
  refetch 
} = useFetctApplicableYearTariffCodes(applicableYear.value)

// Use computed to reactively access the data
const tariffs = computed(() => fetchedData.value || [])

// Filtered tariffs based on search query
const filteredTariffs = computed(() => {
  if (!searchQuery.value.trim()) {
    return tariffs.value
  }

  const query = searchQuery.value.toLowerCase().trim()
  
  return tariffs.value.filter((item: any) => {
    const code = item.tariff_code?.code?.toLowerCase() || ''
    const description = item.tariff_code?.code_description?.toLowerCase() || ''
    const year = item.applicable_year?.toString() || ''
    
    return code.includes(query) || 
           description.includes(query) || 
           year.includes(query)
  })
})

// Clear search
const clearSearch = () => {
  searchQuery.value = ''
}

// Computed property for safe access
const hasResults = computed(() => filteredTariffs.value.length > 0)

// Computed for selected count
const selectedCount = computed(() => tariffCodeSunsetDataList.value.length)

// Computed to check if any tariffs are selected
const hasSelection = computed(() => selectedCount.value > 0)

// Check if all visible (filtered) items are selected
const allVisibleSelected = computed(() => {
  return filteredTariffs.value.length > 0 && 
    filteredTariffs.value.every((item: any) => isSelected(item))
})

// Check if some (but not all) visible items are selected
const someVisibleSelected = computed(() => {
  const selectedInVisible = filteredTariffs.value.filter((item: any) => isSelected(item)).length
  return selectedInVisible > 0 && selectedInVisible < filteredTariffs.value.length
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (tariff.value)
      ? (_openBlock(), _createBlock(TariffCodeDetailDialog, {
          key: 0,
          tariff: tariff.value,
          open: isDialogOpen.value,
          "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((isDialogOpen).value = $event))
        }, null, 8, ["tariff", "open"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(Dialog), {
      open: isSyncSunsetDialogOpen.value,
      "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((isSyncSunsetDialogOpen).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogContent), { class: "max-w-2xl bg-white" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), { class: "text-2xl flex items-center gap-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SunsetIcon), { class: "h-6 w-6 text-amber-600" }),
                    _cache[14] || (_cache[14] = _createTextVNode(" Sync Sunset Date ", -1))
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), null, {
                  default: _withCtx(() => [
                    _createTextVNode(" Set the sunset date for " + _toDisplayString(selectedCount.value) + " selected tariff code(s) ", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h3", _hoisted_3, " Selected Tariff Codes (" + _toDisplayString(selectedCount.value) + ") ", 1),
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tariffCodeSunsetDataList, (item) => {
                    return (_openBlock(), _createBlock(_unref(Badge), {
                      key: item.rate_id,
                      variant: "outline",
                      class: "font-mono"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.tariff_code.code), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "text-sm font-semibold text-gray-700" }, [
                  _createTextVNode(" Sunset Date "),
                  _createElementVNode("span", { class: "text-red-500" }, "*")
                ], -1)),
                _createVNode(_unref(Popover), { class: "bg-slate-100" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(PopoverTrigger), { "as-child": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Button), {
                          variant: "outline",
                          class: _normalizeClass(_unref(cn)(
                    'w-full justify-start text-left font-normal',
                    !sunsetDate.value && 'text-muted-foreground'
                  ))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(CalendarIcon), { class: "mr-2 h-4 w-4" }),
                            (sunsetDate.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(formatDateToYYYYMMDD(sunsetDate.value)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_7, "Pick a date"))
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(PopoverContent), {
                      class: "w-auto p-0 bg-white",
                      align: "start"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Calendar), {
                          modelValue: sunsetDate.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sunsetDate).value = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("p", _hoisted_8, [
                  _cache[15] || (_cache[15] = _createTextVNode(" Format: YYYY/MM/DD ", -1)),
                  (sunsetDate.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Selected: " + _toDisplayString(formatDateToYYYYMMDD(sunsetDate.value)), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_unref(AlertCircle), { class: "h-5 w-5 text-blue-600" })
                  ]),
                  _createElementVNode("div", null, [
                    _cache[19] || (_cache[19] = _createElementVNode("h4", { class: "text-sm font-semibold text-blue-400 mb-1" }, "Summary", -1)),
                    _createElementVNode("p", _hoisted_13, [
                      _cache[18] || (_cache[18] = _createTextVNode(" You are about to sync ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(selectedCount.value) + " tariff code(s)", 1),
                      (sunsetDate.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                            _cache[17] || (_cache[17] = _createTextVNode(" with sunset date ", -1)),
                            _createElementVNode("strong", null, _toDisplayString(formatDateToYYYYMMDD(sunsetDate.value)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode(_unref(DialogFooter), null, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  variant: "outline",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (isSyncSunsetDialogOpen.value = false)),
                  disabled: isSyncing.value
                }, {
                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                    _createTextVNode(" Cancel ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_unref(Button), {
                  onClick: handleSyncSunset,
                  disabled: !sunsetDate.value || isSyncing.value,
                  class: "bg-amber-600 hover:bg-amber-700"
                }, {
                  default: _withCtx(() => [
                    (isSyncing.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_unref(SunsetIcon), { class: "mr-2 h-4 w-4" }),
                          _cache[21] || (_cache[21] = _createTextVNode(" Sync Sunset ", -1))
                        ], 64))
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_unref(Dialog), {
      open: isSyncDisciplinesDialogOpen.value,
      "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((isSyncDisciplinesDialogOpen).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogContent), { class: "max-w-2xl bg-white" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), { class: "text-2xl flex items-center gap-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(RepeatIcon), { class: "h-6 w-6 text-[#255f7a]" }),
                    _cache[22] || (_cache[22] = _createTextVNode(" Sync Disciplines ", -1))
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), null, {
                  default: _withCtx(() => [
                    _createTextVNode(" Review " + _toDisplayString(selectedCount.value) + " selected tariff code(s) before syncing disciplines ", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("h3", _hoisted_18, " Selected Tariff Codes (" + _toDisplayString(selectedCount.value) + ") ", 1),
                _createElementVNode("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tariffCodeSunsetDataList, (item) => {
                    return (_openBlock(), _createBlock(_unref(Badge), {
                      key: item.rate_id,
                      variant: "outline",
                      class: "font-mono"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.tariff_code.code), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_unref(AlertCircle), { class: "h-5 w-5 text-blue-600" })
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _cache[25] || (_cache[25] = _createElementVNode("h4", { class: "text-sm font-semibold text-blue-900 mb-2" }, "What's Next?", -1)),
                    _createElementVNode("p", _hoisted_24, [
                      _cache[23] || (_cache[23] = _createTextVNode(" You are about to sync disciplines for ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(selectedCount.value) + " tariff code(s)", 1),
                      _cache[24] || (_cache[24] = _createTextVNode(". ", -1))
                    ]),
                    _cache[26] || (_cache[26] = _createElementVNode("ul", { class: "text-sm text-blue-700 space-y-1 list-disc list-inside" }, [
                      _createElementVNode("li", null, "Review the selected tariff codes above"),
                      _createElementVNode("li", null, "Click \"Next\" to proceed"),
                      _createElementVNode("li", null, "You can configure additional settings on the next page")
                    ], -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("p", _hoisted_27, _toDisplayString(selectedCount.value), 1),
                  _cache[27] || (_cache[27] = _createElementVNode("p", { class: "text-xs text-purple-600 mt-1" }, "Tariff Codes", -1))
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("p", _hoisted_29, _toDisplayString(applicableYear.value), 1),
                  _cache[28] || (_cache[28] = _createElementVNode("p", { class: "text-xs text-green-600 mt-1" }, "Applicable Year", -1))
                ]),
                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "bg-gradient-to-br from-orange-50 to-orange-100 border border-orange-200 rounded-lg p-4 text-center" }, [
                  _createElementVNode("p", { class: "text-2xl font-bold text-orange-700" }, "Ready"),
                  _createElementVNode("p", { class: "text-xs text-orange-600 mt-1" }, "Status")
                ], -1))
              ])
            ]),
            _createVNode(_unref(DialogFooter), null, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  variant: "outline",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (isSyncDisciplinesDialogOpen.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                    _createTextVNode(" Cancel ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  onClick: navigateToStageRollover,
                  class: "bg-[#255f7a] hover:bg-[#1d4a5f] text-white"
                }, {
                  default: _withCtx(() => [
                    _cache[31] || (_cache[31] = _createTextVNode(" Next ", -1)),
                    _createVNode(_unref(ArrowRight), { class: "ml-2 h-4 w-4" })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]),
    (_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [...(_cache[32] || (_cache[32] = [
          _createElementVNode("div", { class: "text-center" }, [
            _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-slate-600 mx-auto mb-4" }),
            _createElementVNode("p", { class: "text-gray-600" }, "Loading tariff codes...")
          ], -1)
        ]))]))
      : (_unref(isError))
        ? (_openBlock(), _createBlock(_unref(Card), {
            key: 2,
            class: "border-red-200 bg-red-50 m-8"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(CardContent), { class: "flex flex-col items-center justify-center py-12" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AlertCircle), { class: "h-12 w-12 text-red-600 mb-4" }),
                  _cache[34] || (_cache[34] = _createElementVNode("p", { class: "text-red-600 font-semibold mb-2" }, "Error loading tariff codes", -1)),
                  _createElementVNode("p", _hoisted_31, _toDisplayString(_unref(error)?.message), 1),
                  _createVNode(_unref(Button), {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(refetch)())),
                    variant: "outline",
                    class: "mt-4 border-red-600 text-red-600 hover:bg-red-600 hover:text-white"
                  }, {
                    default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                      _createTextVNode(" Retry ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (tariffs.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", _hoisted_35, [
                      _cache[35] || (_cache[35] = _createTextVNode(" Tariff Codes - ", -1)),
                      _createElementVNode("span", _hoisted_36, _toDisplayString(tariffs.value.length), 1)
                    ]),
                    _createElementVNode("p", _hoisted_37, [
                      _cache[36] || (_cache[36] = _createTextVNode(" Manage and view tariff codes ", -1)),
                      (selectedCount.value > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_38, " (" + _toDisplayString(selectedCount.value) + " selected) ", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    (selectedCount.value > 0)
                      ? (_openBlock(), _createBlock(_unref(Button), {
                          key: 0,
                          variant: "outline",
                          class: "flex items-center gap-2 text-red-600 border-red-300 hover:bg-red-50",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (deselectAll()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Trash2), { class: "h-4 w-4" }),
                            _createTextVNode(" Clear Selection (" + _toDisplayString(selectedCount.value) + ") ", 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!allVisibleSelected.value && filteredTariffs.value.length > 0)
                      ? (_openBlock(), _createBlock(_unref(Button), {
                          key: 1,
                          variant: "outline",
                          class: "flex items-center gap-2",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (selectAll()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Select All " + _toDisplayString(searchQuery.value ? 'Filtered' : ''), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(Button), {
                      variant: "outline",
                      class: "flex items-center gap-3 rounded-md justify-between bg-amber-500 text-white p-2 text-md hover:bg-green-800 hover:text-white",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.push('/admin')))
                    }, {
                      default: _withCtx(() => [
                        _cache[37] || (_cache[37] = _createTextVNode(" Merge HBC ", -1)),
                        _createVNode(_unref(Merge))
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Button), {
                      variant: "outline",
                      disabled: !hasSelection.value,
                      class: _normalizeClass([
                'flex items-center gap-3 rounded-md justify-between p-2 text-md',
                hasSelection.value 
                  ? 'bg-amber-700 text-white hover:bg-green-800 hover:text-white' 
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              ]),
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (hasSelection.value ? openSyncSunsetDialog() : null))
                    }, {
                      default: _withCtx(() => [
                        _cache[38] || (_cache[38] = _createTextVNode(" Sync Sunset ", -1)),
                        _createVNode(_unref(SunsetIcon))
                      ]),
                      _: 1
                    }, 8, ["disabled", "class"]),
                    _createVNode(_unref(Button), {
                      variant: "outline",
                      disabled: !hasSelection.value,
                      class: _normalizeClass([
                'flex items-center gap-3 rounded-md justify-between p-2 text-md font-medium hover:shadow-lg',
                hasSelection.value 
                  ? 'bg-[#255f7a] text-white hover:bg-green-800 hover:text-white' 
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              ]),
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (hasSelection.value ? openSyncDisciplinesDialog() : null))
                    }, {
                      default: _withCtx(() => [
                        _cache[39] || (_cache[39] = _createTextVNode(" Sync Disciplines ", -1)),
                        _createVNode(_unref(RepeatIcon))
                      ]),
                      _: 1
                    }, 8, ["disabled", "class"]),
                    _createVNode(_unref(Button), {
                      variant: "outline",
                      class: "flex items-center gap-3 rounded-md bg-slate-800 text-white p-2 text-md font-medium hover:bg-green-800 hover:text-white hover:shadow-lg",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (handleSuccess()))
                    }, {
                      default: _withCtx(() => [
                        _cache[40] || (_cache[40] = _createTextVNode(" Upload ", -1)),
                        _createVNode(_unref(UploadIcon), { class: "h-4 w-4" })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_unref(Search), { class: "absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" }),
                  _createVNode(_unref(Input), {
                    modelValue: searchQuery.value,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((searchQuery).value = $event)),
                    placeholder: "Search by tariff code, description, or year...",
                    class: "pl-10 pr-10"
                  }, null, 8, ["modelValue"]),
                  (searchQuery.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: clearSearch,
                        class: "absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                      }, [
                        _createVNode(_unref(X), { class: "h-4 w-4" })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (searchQuery.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_41, " Found " + _toDisplayString(filteredTariffs.value.length) + " result(s) matching \"" + _toDisplayString(searchQuery.value) + "\" ", 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(Table), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(TableHeader), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TableRow), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(TableHead), { class: "w-12" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Checkbox), {
                                checked: allVisibleSelected.value,
                                indeterminate: someVisibleSelected.value,
                                onClick: toggleSelectAll
                              }, null, 8, ["checked", "indeterminate"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(TableHead), null, {
                            default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                              _createTextVNode("Tariff Code", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_unref(TableHead), null, {
                            default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                              _createTextVNode("Description", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_unref(TableHead), { class: "text-center" }, {
                            default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                              _createTextVNode("Year", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_unref(TableHead), { class: "text-center" }, {
                            default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                              _createTextVNode("Limits", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_unref(TableHead), { class: "text-center" }, {
                            default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                              _createTextVNode("Status", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_unref(TableHead), { class: "text-center" }, {
                            default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                              _createTextVNode("Actions", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(TableBody), null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTariffs.value, (tariffItem) => {
                        return (_openBlock(), _createBlock(_unref(TableRow), {
                          key: tariffItem.rate_id,
                          class: _normalizeClass([
              isSelected(tariffItem) ? 'bg-blue-50 hover:bg-blue-100' : 'hover:bg-gray-50'
            ])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(TableCell), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Checkbox), {
                                  checked: isSelected(tariffItem),
                                  onClick: () => toggleSelection(tariffItem, !isSelected(tariffItem))
                                }, null, 8, ["checked", "onClick"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_unref(TableCell), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Badge), {
                                  variant: "outline",
                                  class: _normalizeClass([
                  'font-mono',
                  isSelected(tariffItem) ? 'border-green-300 text-green-600' : ''
                ])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(tariffItem.tariff_code.code), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["class"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_unref(TableCell), { class: "max-w-md" }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", {
                                  class: "text-sm truncate",
                                  title: tariffItem.tariff_code.code_description
                                }, _toDisplayString(tariffItem.tariff_code.code_description), 9, _hoisted_42)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_unref(TableCell), { class: "text-center" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Badge), { variant: "secondary" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(tariffItem.applicable_year), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_unref(TableCell), { class: "text-center" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(tariffItem.applicable_limits), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_unref(TableCell), { class: "text-center" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Badge), {
                                  variant: tariffItem.active ? 'default' : 'secondary'
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(tariffItem.active ? 'Active' : 'Inactive'), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["variant"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_unref(TableCell), { class: "text-center" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Button), {
                                  variant: "ghost",
                                  size: "lg",
                                  onClick: ($event: any) => (handleViewTariffCodeDetail(tariffItem))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Eye), { class: "h-4 w-4" })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["class"]))
                      }), 128)),
                      (filteredTariffs.value.length === 0)
                        ? (_openBlock(), _createBlock(_unref(TableRow), { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(TableCell), {
                                colspan: "7",
                                class: "text-center py-12"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_43, [
                                    _createVNode(_unref(Search), { class: "h-12 w-12 text-gray-300 mb-3" }),
                                    _cache[48] || (_cache[48] = _createElementVNode("p", { class: "text-gray-500 font-medium" }, "No tariff codes found", -1)),
                                    _cache[49] || (_cache[49] = _createElementVNode("p", { class: "text-sm text-gray-400 mt-1" }, "Try adjusting your search", -1)),
                                    _createVNode(_unref(Button), {
                                      variant: "outline",
                                      size: "sm",
                                      onClick: clearSearch,
                                      class: "mt-3"
                                    }, {
                                      default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                                        _createTextVNode(" Clear Search ", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createBlock(_unref(Card), {
              key: 4,
              class: "m-8"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(CardContent), { class: "flex flex-col items-center justify-center py-12" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(AlertCircle), { class: "h-12 w-12 text-gray-400 mb-4" }),
                    _cache[50] || (_cache[50] = _createElementVNode("p", { class: "text-gray-500" }, "No tariff codes available", -1))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
  ]))
}
}

})